export default "__VITE_ASSET__CSmXk7_x__"